export default __webpack_public_path__ + "static/media/ArrowDownLongBlack.33121bd5.svg";